import barba from '@barba/core'
import { debounce, getViewportWidth, getViewportHeight } from '../utilities'
import {
  transitionTimingMilliseconds,
  reducedMotion,
} from '../utilities/constants'

const activeClass = 'is-active'
const listSelector = '.js-navList'
const itemSelector = '.js-navItem'
const linkSelector = '.js-navLink'
const toggleSelector = '.js-navToggle'
const logoSelector = '.js-logo'
const linkSelectorClean = linkSelector.split('.').join('') // without starting dot

/*
TODO:
- Allow mousemove on inTransition, and set active hover el to the one after transition is done, not active menu item
*/

export default class {
  constructor(containerEl, options) {
    this.options = options = Object.assign(
      {
        threshold: 800,
        openonload: false,
      },
      options
    )

    const navToggle = document.querySelector(toggleSelector)
    let viewportWidth = getViewportWidth()
    let viewportHeight = 0

    function toggleMenu(force = null) {
      let newState

      if (typeof force === 'boolean') {
        newState = force
      } else {
        newState = !containerEl.classList.contains(activeClass)
      }

      containerEl.classList.toggle(activeClass, newState)
      navToggle.classList.toggle(activeClass, newState)

      navToggle.setAttribute('aria-expanded', newState ? 'true' : 'false')
    }

    navToggle.addEventListener(
      'click',
      function () {
        toggleMenu()
      },
      false
    )

    if (options.openonload && viewportWidth < options.threshold) {
      toggleMenu(true)
    }

    const logoEl = containerEl.querySelector(logoSelector)
    const list = containerEl.querySelector(listSelector)

    if (!list) {
      return
    }

    const listItems = Array.from(containerEl.querySelectorAll(itemSelector))
    const listLinks = Array.from(containerEl.querySelectorAll(linkSelector))
    const itemCount = listItems.length
    let move = 0
    let listItemHeight = 0
    const listItemTransitionTiming = 250
    let inTransition = false

    function getActiveMenuItem() {
      const urlParse = barba.url.parse(barba.url.getHref())
      const isSearch =
        urlParse.query && Object.keys(urlParse.query).includes('s')

      if (isSearch) {
        return false
      }

      const path = barba.url.getPath(barba.url.getHref())
      const parentPageUrl =
        path === '/'
          ? `${barba.url.getOrigin()}/`
          : `${barba.url.getOrigin()}/${path.split('/')[1]}/`
      const activeLink = list.querySelector(
        `${linkSelector}[href="${parentPageUrl}"]`
      )

      return activeLink ? activeLink.parentNode : false
    }

    list.querySelectorAll(linkSelector).forEach(function (linkEl) {
      linkEl.addEventListener('click', function (e) {
        // If same url as clicked
        if (e.currentTarget.getAttribute('href') === barba.url.getHref()) {
          e.preventDefault()
          toggleMenu(false)
        }
      })

      // const linkLetters = linkEl.textContent.split('')
      // linkEl.innerHTML = ''
      // linkLetters.forEach(function (letter) {
      //   linkEl.innerHTML += `<span>${letter}</span>`
      // })
    })

    barba.hooks.before(function () {
      inTransition = true
    })

    barba.hooks.after(function () {
      inTransition = false

      if (viewportWidth < options.threshold) {
        toggleMenu(false)
      }

      if (viewportWidth > options.threshold) {
        const activeItem = getActiveMenuItem()

        if (activeItem) {
          move = listItemHeight / 2
          setActiveItem(activeItem)
        } else {
          move = listItemHeight / 2.5 // TODO: This might only looks nice is there are 5 items
          resetMenuItems()
        }
      }
    })

    if (reducedMotion) {
      list.classList.add(activeClass)
      return
    }

    let previousHover = false

    function onMouseLeave(e) {
      if (!inTransition) {
        previousHover = false
        resetMenuItems()
      }

      if (
        !e.relatedTarget || // Leave outside viewport
        (!e.relatedTarget.classList.contains(linkSelectorClean) &&
          !e.relatedTarget.parentNode.classList.contains(linkSelectorClean)) // Leave to other than other menu link
      ) {
        const activeItem = getActiveMenuItem()

        if (activeItem) {
          setActiveItem(activeItem)
        } else {
          resetMenuItems()
        }
      } else {
        // Leave to next link
        resetMenuItems()
      }
    }

    function onMouseMove(e) {
      if (inTransition) {
        return
      }

      // if (Math.abs(e.movementX) > 2 || Math.abs(e.movementY) > 2) {
      //   return
      // }

      const linkTarget = e.target.classList.contains(linkSelectorClean)
        ? e.target
        : e.target.parentNode.classList.contains(linkSelectorClean)
          ? e.target.parentNode
          : false

      if (linkTarget && previousHover !== linkTarget) {
        const activeItem = linkTarget.parentNode
        setActiveItem(activeItem)
        previousHover = linkTarget
      }
    }

    function onFocus(e) {
      if (inTransition) {
        return
      }

      const linkTarget = e.target.classList.contains(linkSelectorClean)
        ? e.target
        : e.target.parentNode.classList.contains(linkSelectorClean)
          ? e.target.parentNode
          : false

      if (linkTarget && previousHover !== linkTarget) {
        const activeItem = linkTarget.parentNode
        setActiveItem(activeItem)
        previousHover = linkTarget
      }
    }

    function onBlur(e) {
      if (!inTransition) {
        previousHover = false
        resetMenuItems()
      }

      if (
        !e.relatedTarget || // Leave outside viewport
        (!e.relatedTarget.classList.contains(linkSelectorClean) &&
          !e.relatedTarget.parentNode.classList.contains(linkSelectorClean)) // Leave to other than other menu link
      ) {
        const activeItem = getActiveMenuItem()

        if (activeItem) {
          setActiveItem(activeItem)
        } else {
          resetMenuItems()
        }
      } else {
        // Leave to next link
        resetMenuItems()
      }
    }

    function initialize(wait = true) {
      viewportWidth = getViewportWidth()
      listItemHeight = listItems[0].offsetHeight
      const activeItem = getActiveMenuItem()

      move = activeItem ? listItemHeight / 2 : listItemHeight / 2.5

      // TODO: navToggle.setAttribute('aria-expanded', newState ? 'true' : 'false')

      if (viewportWidth > options.threshold) {
        viewportHeight = getViewportHeight()
        containerEl.style.transition = ''

        list.addEventListener('mousemove', onMouseMove, false)

        listItems.forEach(function (listItem) {
          listItem.addEventListener('mouseleave', onMouseLeave, false)
        })

        listLinks.forEach(function (listLink) {
          listLink.addEventListener('blur', onBlur, false)
          listLink.addEventListener('focus', onFocus, false)
        })

        resetMenuItems()

        window.setTimeout(
          function () {
            list.classList.add(activeClass)

            listItems.forEach(function (listItem) {
              listItem.style.transition = `transform ${listItemTransitionTiming}ms ease`
            })

            const activeItem = getActiveMenuItem()

            if (activeItem) {
              setActiveItem(activeItem)
            }
          },
          wait ? 100 : 0
        )

        const foldedItemsTotalHeight = 0.5 * listItems.length + 0.5
        logoEl.style.height =
          viewportHeight - listItemHeight * foldedItemsTotalHeight + 'px'
      } else {
        logoEl.style.height = ''

        window.setTimeout(
          function () {
            containerEl.style.transition = `transform ${transitionTimingMilliseconds}ms ease`

            list.classList.add(activeClass)
          },
          wait ? 100 : 0
        )

        list.removeEventListener('mousemove', onMouseMove, false)

        listItems.forEach(function (listItem) {
          listItem.style.transform = ''
          listItem.style.transition = ''
          listItem.removeEventListener('mouseleave', onMouseLeave, false)
        })

        listLinks.forEach(function (listLink) {
          listLink.removeEventListener('blur', onBlur, false)
          listLink.removeEventListener('focus', onFocus, false)
        })
      }
    }

    function resetMenuItems() {
      listItems.forEach(function (listItem, index) {
        listItem.style.transform =
          viewportWidth > options.threshold
            ? `translateY(${(itemCount - index) * move - 1}px)`
            : ''
      })
    }

    function setActiveItem(el) {
      const listChildren = Array.from(list.children)
      const activeIndex = listChildren.indexOf(el)
      const startThing = listChildren.length - activeIndex
      const itemsBelowActiveItem = listChildren.splice(0, activeIndex).reverse()

      // viewportWidth = getViewportWidth()

      resetMenuItems()

      el.style.transform = `translateY(${
        (itemCount - activeIndex - 1) * move
      }px)`

      if (activeIndex !== 0) {
        itemsBelowActiveItem.forEach(function (el, index) {
          const newThing = startThing + 2 * index
          el.style.transform = `translateY(${
            (itemCount - activeIndex + newThing) * (move / 2)
          }px)`
        })
      }
    }

    initialize()

    window.addEventListener(
      'resize',
      debounce(function () {
        initialize(false)
      }, 600)
    )
  }
}
